define("checkout/components/payment", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/template-only",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <h3 class="tCH--title--h2 tCH--text--highlight qa--checkout__payment--title" data-test-id="payment-title">
    {{t "plans.checkout.plan.step_2"}}
  </h3>
  
  {{#if @hasActiveSubscription}}
    <div class="u--row u--row--noCollapse">
      <div class="u--col__9">
        <p class="u--text--bold u--m__b__xs">{{t "plans.checkout.card.title"}}</p>
        <span>
          {{t "plans.checkout.card.summary" brand=@stripeCard.brand last4=@stripeCard.last4}}
        </span>
  
        <span class="u--p__l__lg">
          {{t "plans.checkout.card.expiration" expiration=@stripeCard.exp_month}}/{{@stripeCard.exp_year}}
        </span>
      </div>
      <div class="u--col__3 u--text--right">
        <Shared::Button::UpdateCard
          class="qa--checkout__payment--editCard"
          @billingEmail={{@currentAccount.canonicalBillingEmail}}
          @buttonText={{t "shared_words.edit"}}
          @handleCard={{@handleCard}}
        />
      </div>
    </div>
    <Payment::Address
      @isEditingAddress={{@isEditingAddress}}
      @hideEditingAddress={{@hideEditingAddress}}
      @setEditingAddress={{@setEditingAddress}}
    />
  {{else}}
    <Payment::Card @onCard={{action @onCard}}/>
    <Payment::Address
      @isEditingAddress={{@isEditingAddress}}
      @hideEditingAddress={{@hideEditingAddress}}
      @setEditingAddress={{@setEditingAddress}}
    />
    <Payment::Coupon
      @selectedSubscriptionPlan={{@selectedSubscriptionPlan}}
      @onCoupon={{action @onCoupon}}
    />
  {{/if}}
  
  */
  {
    "id": "VvFNw6BM",
    "block": "[[[10,\"h3\"],[14,0,\"tCH--title--h2 tCH--text--highlight qa--checkout__payment--title\"],[14,\"data-test-id\",\"payment-title\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[\"plans.checkout.plan.step_2\"],null]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[30,1],[[[1,\"  \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--col__9\"],[12],[1,\"\\n      \"],[10,2],[14,0,\"u--text--bold u--m__b__xs\"],[12],[1,[28,[35,0],[\"plans.checkout.card.title\"],null]],[13],[1,\"\\n      \"],[10,1],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"plans.checkout.card.summary\"],[[\"brand\",\"last4\"],[[30,2,[\"brand\"]],[30,2,[\"last4\"]]]]]],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,1],[14,0,\"u--p__l__lg\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"plans.checkout.card.expiration\"],[[\"expiration\"],[[30,2,[\"exp_month\"]]]]]],[1,\"/\"],[1,[30,2,[\"exp_year\"]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"u--col__3 u--text--right\"],[12],[1,\"\\n      \"],[8,[39,2],[[24,0,\"qa--checkout__payment--editCard\"]],[[\"@billingEmail\",\"@buttonText\",\"@handleCard\"],[[30,3,[\"canonicalBillingEmail\"]],[28,[37,0],[\"shared_words.edit\"],null],[30,4]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[8,[39,3],null,[[\"@isEditingAddress\",\"@hideEditingAddress\",\"@setEditingAddress\"],[[30,5],[30,6],[30,7]]],null],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,4],null,[[\"@onCard\"],[[28,[37,5],[[30,0],[30,8]],null]]],null],[1,\"\\n  \"],[8,[39,3],null,[[\"@isEditingAddress\",\"@hideEditingAddress\",\"@setEditingAddress\"],[[30,5],[30,6],[30,7]]],null],[1,\"\\n  \"],[8,[39,6],null,[[\"@selectedSubscriptionPlan\",\"@onCoupon\"],[[30,9],[28,[37,5],[[30,0],[30,10]],null]]],null],[1,\"\\n\"]],[]]]],[\"@hasActiveSubscription\",\"@stripeCard\",\"@currentAccount\",\"@handleCard\",\"@isEditingAddress\",\"@hideEditingAddress\",\"@setEditingAddress\",\"@onCard\",\"@selectedSubscriptionPlan\",\"@onCoupon\"],false,[\"t\",\"if\",\"shared/button/update-card\",\"payment/address\",\"payment/card\",\"action\",\"payment/coupon\"]]",
    "moduleName": "checkout/components/payment.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});